import React from "react";

/**
 * Minimal Markdown renderer (no external dep).
 * Supports: # H1, ## H2, ### H3, **bold**, *italic*, [link](url), - bullet list, 1. numbered list.
 */
export default function MarkdownRender({ md = "" }) {
  if (!md) return null;
  const lines = String(md).split("\n");
  const blocks = [];
  let listBuf = [];
  let listType = null;

  const flushList = () => {
    if (listBuf.length === 0) return;
    const Tag = listType === "ol" ? "ol" : "ul";
    blocks.push(
      <Tag
        key={blocks.length}
        className={listType === "ol" ? "list-decimal ms-6 mb-4" : "list-disc ms-6 mb-4"}
      >
        {listBuf.map((li, i) => (
          <li key={i} dangerouslySetInnerHTML={{ __html: inline(li) }} />
        ))}
      </Tag>
    );
    listBuf = [];
    listType = null;
  };

  function inline(s) {
    return s
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
      .replace(/\*(.+?)\*/g, "<em>$1</em>")
      .replace(/\[(.+?)\]\((.+?)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
  }

  for (const raw of lines) {
    const line = raw.trim();
    if (!line) {
      flushList();
      continue;
    }
    if (/^### /.test(line)) {
      flushList();
      blocks.push(<h3 key={blocks.length} dangerouslySetInnerHTML={{ __html: inline(line.slice(4)) }} />);
      continue;
    }
    if (/^## /.test(line)) {
      flushList();
      blocks.push(<h2 key={blocks.length} dangerouslySetInnerHTML={{ __html: inline(line.slice(3)) }} />);
      continue;
    }
    if (/^# /.test(line)) {
      flushList();
      blocks.push(<h1 key={blocks.length} dangerouslySetInnerHTML={{ __html: inline(line.slice(2)) }} />);
      continue;
    }
    if (/^- /.test(line)) {
      if (listType !== "ul") flushList();
      listType = "ul";
      listBuf.push(line.slice(2));
      continue;
    }
    if (/^\d+\. /.test(line)) {
      if (listType !== "ol") flushList();
      listType = "ol";
      listBuf.push(line.replace(/^\d+\.\s/, ""));
      continue;
    }
    flushList();
    blocks.push(<p key={blocks.length} dangerouslySetInnerHTML={{ __html: inline(line) }} />);
  }
  flushList();
  return <>{blocks}</>;
}
